// extracted by mini-css-extract-plugin
module.exports = {"addBtn":"cgRnpzA2mNAD6guDpHNCu","icon":"PNKfBGeb1mkKqTb6zedch"};